import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import Category from "../entities/pdv/category.entity";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class CategoryDB extends FirestorePipe {

  public static readonly colName = 'Categories'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${CategoryDB.colName}`);
  }

  public async create(data: Category): Promise<any> {
    await this.saveFile(data);
    try {
      return await this._create(data);
    } catch (error: any) {
      if(data.image_ref) {
        await this.deleteFile(data.image_ref)
      }
      throw error.message
    }
  }
  public async update(id: string, data: Category): Promise<any> {
    await this.saveFile(data);
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<Category[]> {
    return this._getAll<Category>(...params);
  }
  public get(id: string): Promise<Category> {
    return this._get(id);
  }
  public on(listener: (data: Category[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

  private async saveFile(data: Category) {
    if(data.image) {
      const resultUpload = await this.uploadFile(new Date().getTime().toString(), data.image);
      data.image_ref = resultUpload.ref.fullPath;
      data.image_url = resultUpload.url;
    }
    delete data.image
  }

}

export default CategoryDB;